module.exports = __webpack_public_path__ + "img/Wisdom.4150692a.png";